<template>
  <v-row
    class="px-4 pt-3 pb-4 details-proposal__card details-proposal__card--desktop"
  >
    <v-col cols="12">
      <p class="primary--text font-weight-bold">
        Outras Informações
      </p>
    </v-col>
    <v-col cols="12" class="details-proposal__item-auto">
      <v-row class="pa-4">
        <v-col cols="12">
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Seguradora:
            <label class="details-proposal__value primary--text">
              {{ insuranceCompany }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Área Segurada:
            <label class="details-proposal__value primary--text">
              {{ form.area_segurada }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Valor da Planta:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.valor_planta) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            POS:
            <label class="details-proposal__value primary--text">
              {{ form.tipo_pos.name }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Prêmio Total:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.premio_total) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Prêmio do Segurado:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.premio_segurado) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Subvenção Federal:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.subvencao_federal) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Subvenção Estadual:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.subvencao_estadual) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Investimento RS/ha:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.investimento) }}
            </label>
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<style scoped>
@media (min-width: 960px) {
  .details-proposal__card--desktop {
    height: 420px;
  }
}
</style>

<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
import { asMoneyString, formatIsoDateToDDMMYYYY } from "@/utils/formats.js";

export default {
  name: "QuotationProposalAgricolaInformation",
  mixins: [DocumentsMixin],
  data() {
    return {
      asMoneyString,
      formatIsoDateToDDMMYYYY,
      closeTable: false
    };
  },
  methods: {
    closeTableBillingFile() {
      return (this.closeTable = true);
    }
  },
  computed: {
    hasAditionalCoverage() {
      return this.form.tipo_cobertura?.id === "basica_replantio";
    },
    isProductivity() {
      return this.form.tipo_seguro == "produtividade";
    },
    insuranceCompany() {
      return this.form.seguradora?.nome;
    },
    insuranceType() {
      return this.form.tipo_seguro?.nome;
    },
    claimType() {
      return this.form.tipo_reivindicacao?.nome;
    }
  },
  props: {
    form: {
      type: Object
    },
    isPolicy: {
      type: Boolean,
      default: false
    }
  }
};
</script>
